import React from 'react';
import BaseFaq from 'components/Faq';
import NextLink from 'next/link';
import { Link } from '@mui/material';
import { getEnv } from 'utils';

export default function Faq() {
  return (
    <BaseFaq
      items={[
        {
          question: 'What are infographic templates?',
          answer: [
            'Infographic templates are ready-to-edit infographics created by our design team. You can use them as inspiration or start-point for your creations.',
          ],
        },
        {
          question: 'Where can I get free infographic templates?',
          answer: [
            <>
              You can get free infographic templates{' '}
              <NextLink href="/infographic-templates" passHref={true}>
                <Link underline="hover">here</Link>
              </NextLink>{' '}
              in our infographic template tab.
            </>,
          ],
        },
        {
          question: 'How do I make an infographic template?',
          answer: [
            <>
              To make an infographic template you’ll need an account at Mind the Graph and some
              creativity to start creating.{' '}
              <NextLink
                href={`${getEnv(
                  'MTG_URL_APP',
                )}/blog/tutorial-video-creating-a-four-steps-infographic-template`}
                passHref={true}
              >
                <Link underline="hover">Click here</Link>
              </NextLink>{' '}
              and learn simple steps to create an eye-catching infographic.
            </>,
          ],
        },
        {
          question: 'What are the 7 types of infographics?',
          answer: [
            <>
              The 7 types of infographics are: statistical, timelines, processes, comparisons,
              lists, geographic, and informational. You can learn more about the difference between
              infographics and graphical abstract{' '}
              <NextLink
                href={`${getEnv('MTG_URL_APP')}/blog/graphical-abstracts-vs-infographics/`}
                passHref={true}
              >
                <Link underline="hover">here</Link>
              </NextLink>
              .{' '}
            </>,
          ],
        },
      ]}
    />
  );
}
